import store from '../store'

export function getPriceFromState(tokenName: string) {
    const getPriceStore = store.getState().pricing.getPrice
    try {
        const price = getPriceStore(tokenName)
        return price
    } catch (error) {
        console.log('YSYS error=', error)
        return undefined
    }
}
